import clsx from 'clsx';
import Review from './Review';
import styles from './ReviewList.module.scss';
import type { Dispatch, SetStateAction } from 'react';
import type { ReviewItem } from 'types/Review';

const INITIALLY_SHOWN_REVIEWS = 4;

type Props = {
  reviews: ReviewItem[];
  isShownAll?: boolean;
  onReviewCardClick?: () => void;
  setSelectedCardIndex?: Dispatch<SetStateAction<number>>;
};

const ReviewsList = ({
  reviews,
  isShownAll,
  onReviewCardClick,
  setSelectedCardIndex,
}: Props): JSX.Element => {
  return (
    <div className={clsx(styles.wrapper, isShownAll && styles.insideModal)}>
      {reviews
        ?.slice(0, isShownAll ? reviews.length : INITIALLY_SHOWN_REVIEWS)
        .map((review, i) => (
          <Review
            {...review}
            key={i}
            isShownAll={isShownAll}
            onReviewCardClick={() => {
              setSelectedCardIndex?.(i);
              onReviewCardClick?.();
            }}
          />
        ))}
    </div>
  );
};

export default ReviewsList;
